export const breakpoints = {
  mobile: '(min-width: 320px)',
  tablet: '(min-width: 501px)',
  normal: '(min-width: 769px)',
  widescreen: '(min-width: 1201px)',
  landscape: '(max-height: 500px)',
};
